(function () {

  'use strict';

  /**
   * @author Zain Syed | Chester Rivas
   * @ngdoc factory
   * @name uteCoreFactory
   * @description
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .factory('uteCoreFactory', ["$rootScope", "$window", function ($rootScope, $window) {

      var uteCoreFactory = {};

      uteCoreFactory.collections = {};

      uteCoreFactory.collections.userPref = $window.__userPref;

      uteCoreFactory.collections.userInfo = $window.__userInfo;

      uteCoreFactory.collections.atg = $window.__atg;

      uteCoreFactory.multiPageMode = false;

      $rootScope.$watch('userPref', function (nv, ov) {

        if (nv === {} || _.isEmpty(nv)) {
          console.warn('try to set to empty, NO NO!');
        }

        if (ov !== nv && nv !== {}) {
          uteCoreFactory.collections.userPref = nv;
        }

      }, true);

      $rootScope.$watch('userInfo', function (nv, ov) {

        if (ov !== nv) {
          uteCoreFactory.collections.userInfo = nv;
        }

      }, true);

      $rootScope.$watch('atg', function (nv, ov) {

        if (ov !== nv) {
          uteCoreFactory.collections.atg = nv;
        }

      }, true);

      return uteCoreFactory;

    }]);

})();
